import { EventTypes } from "../eventtype.model";

export const PagodaEventTypes: EventTypes[] = [
  {
    label: "Total User Sessions",
    name: "vv_user_session_start",
    events: ["vv_user_session_start", "vv_user_session_start_banter"],
  },
  {
    label: "Total Virtual Try-On Sessions",
    name: "vv_vto_show_request",
    events: [
      "vv_vto_show_request",
      "vv_vto_show_request_banter",
      "vv_vto_show_request_ab_test",
      "vv_vto_nav_show_request",
      "vv_vto_nav_show_request_ab_test",
      "vv_vto_nav_show_request_banter",
    ],
  },
  {
    label: "Total Pictures Taken",
    name: "vv_vto_image_taken",
    events: [
      "vv_vto_image_taken",
      "vv_vto_image_taken_ab_test",
      "vv_vto_image_taken_banter",
    ],
  },
  {
    label: "Total Social Media Requests",
    name: "curalate_show_request",
    events: [
      "curalate_show_request",
      "curalate_item_product_request",
      "curalate_item_show_request",
      "curalate_show_request_banter",
      "curalate_show_request_ab_test",
      "curalate_nav_show_request",
      "curalate_nav_show_request_ab_test",
      "curalate_nav_show_request_banter",
    ],
  },
  {
    label: "Total Social Media Image Views",
    name: "curalate_item_click",
    events: [
      "curalate_item_click",
      "curalate_item_click_ab_test",
      "curalate_item_click_banter",
    ],
  },
  {
    label: "Total Social Media Item Views",
    name: "curalate_product_item_click",
    events: [
      "curalate_product_item_click",
      "curalate_product_item_click_ab_test",
      "curalate_product_item_click_banter",
    ],
  },
  {
    label: "Total number of Tierra Whack Collection Views",
    name: "tierra_whack_show_request_banter",
    events: [
      "tierra_whack_show_request_banter"
    ],
  },
  // {
  //     // below event summary is for bagoda
  //     label: "Total Piercing Collection Views",
  //     name: "piercing_earrings_show_request",
  //     events: [
  //         "piercing_earrings_show_request",
  //         "piercing_earrings_show_request_ab_test",
  //         "piercing_earrings_show_request_banter"
  //     ]
  // },
  // {
  //     label: "Total New Arrival Collection Views",
  //     name: "new_arrivals_show_request",
  //     events :[
  //         "new_arrivals_show_request",
  //         "new_arrivals_show_request_ab_test",
  //         "new_arrivals_show_request_banter",
  //     ]
  // },
  {
    label: "Total Product Views",
    name: "vv_product_select",
    events: [
      "vv_product_select",
      "vv_product_select_ab_test",
      "vv_product_select_banter",
    ],
  },
  //  added changes

  // {
  //     label: "Total VIP Collection Views",
  //     name: "vip_show_request",
  //     events : [
  //         "vip_show_request",
  //         "vip_show_request_ab_test",
  //         "vip_show_request_banter"
  //     ]
  // },
  // {
  //     label: "Average Session Time",
  //     name: "vv_user_session_end",
  //     events : [
  //         "vv_user_session_end",
  //         "vv_user_session_end_banter"
  //     ]
  // },
  // {
  //     label: "Total Category Views",
  //     name: "all_categories_show_request",
  //     events : [
  //         "all_categories_show_request"
  //     ]
  // },
  // {
  //     label: "Total Product Shares",
  //     name: "product_info_share_request",
  //     events : [
  //         "product_info_share_request",
  //     ]
  // },

  {
    label: "Total number of Shop by Piercing events",
    name: "Total number of Shop by Piercing events",
    events: [
      "shop_by_piercing_banter",
      //  "vv_screen",
      "shop_by_piercing_piercing_click_banter",
    ],
  },
  {
    label: "Total number of clicks for each different Piercing Type",
    name: "Total number of clicks for each different Piercing Type",
    events: ["shop_by_piercing_piercing_click_banter"],
  },
  {
    label: "Total number of Shop by Collection events",
    name: "Total number of Shop by Collection events",
    events: [
      "shop_the_collection_show_request_banter",
      "catalog_show_request_banter",
    ],
  },
  {
    label: "Total number of clicks for each different Category",
    name: "Total number of clicks for each different Category",
    events: [
      //need to ask
      "shop_by_piercing_aftercare_click_banter",
      "vto_show_request_banter",
      "curalate_show_request_banter",
      "shop_by_piercing_piercing_click_banter",
      "piercing_product_show_request_banter",
    ],
  },
  {
    label: "Total number of After Care Clicks",
    name: "Total number of After Care Clicks",
    events: ["shop_by_piercing_aftercare_click_banter"],
  },
];

export const PagodaByStoreEvents: any = [
  /*
    {
        label: "1111111111 User Sessions By Store",
        name: "vv_user_session_start",
    },
    {
        label: "Social Media Sessions By Store", //"Total Social Media Requests",
        name: "curalate_show_request",
    },
    {
        label: "Virtual Try-On Sessions By Store",
        name: "vv_vto_show_request",
    },
    {
        label: "Product Views Store ", //"Product Views Store",
        name: "vv_product_select",
    },
    {
        label:"Social Media Content Views Store",
        name: "curalate_item_click",
    },
    {
        label: "Virtual Try-On Photos Takes", // Total Pictures Taken
        name: "vv_vto_image_taken",
    },
    {
        label: "Total Social Media Image Views",
        name: "curalate_item_show_request",
    },
    {
        label : "Total Social Media Item Views",
        name: "curalate_item_product_request",
    },
    {
        label: "Total VIP Collection Views",
        name: "vip_show_request",
    },
    {
        label: "Total New Arrival Collection Views",
        name: "new_arrivals_show_request",
    },
    {
        label: "Total Category Views",
        name: "all_categories_show_request",
    },
    {
        label: "Total Product Shares",
        name: "product_info_share_request",
    },
*/
  /*
User Sessions by Store
Social Media Sessions by Store
Virtual Try-On Sessions by Store
Product Views Store
Social Media Content Views Store
Virtual Try-On Photos Taken
*/
  {
    label: "User Sessions by Store",
    name: "vv_user_session_start",
    events: ["vv_user_session_start", "vv_user_session_start_banter"],
  },
  {
    label: "Total Virtual Try-On Sessions",
    name: "vv_vto_show_request",
    events: [
      "vv_vto_show_request",
      "vv_vto_show_request_banter",
      "vv_vto_show_request_ab_test",
      "vv_vto_nav_show_request",
      "vv_vto_nav_show_request_ab_test",
      "vv_vto_nav_show_request_banter",
    ],
  },
  {
    label: "Total Pictures Taken",
    name: "vv_vto_image_taken",
    events: [
      "vv_vto_image_taken",
      "vv_vto_image_taken_ab_test",
      "vv_vto_image_taken_banter",
    ],
  },
  {
    label: "Total Social Media Requests",
    name: "curalate_show_request",
    events: [
      "curalate_show_request",
      "curalate_item_product_request",
      "curalate_item_show_request",
      "curalate_show_request_banter",
      "curalate_show_request_ab_test",
      "curalate_nav_show_request",
      "curalate_nav_show_request_ab_test",
      "curalate_nav_show_request_banter",
    ],
  },
  {
    label: "Total Social Media Image Views",
    name: "curalate_item_click",
    events: [
      "curalate_item_click",
      "curalate_item_click_ab_test",
      "curalate_item_click_banter",
    ],
  },
  {
    label: "Total Social Media Item Views",
    name: "curalate_product_item_click",
    events: [
      "curalate_product_item_click",
      "curalate_product_item_click_ab_test",
      "curalate_product_item_click_banter",
    ],
  },
  {
    label: "Total New Arrival Collection Views",
    name: "new_arrivals_show_request",
    events: [
      "",
      "new_arrivals_show_request_ab_test",
      "new_arrivals_show_request_banter",
    ],
  },
  {
    label: "Total Product Views",
    name: "vv_product_select",
    events: [
      "vv_product_select",
      "vv_product_select_ab_test",
      "vv_product_select_banter",
    ],
  },
  {
    label: "Total Product View Value",
    name: "vv_product_select_value",
    events: [
      // "vv_product_select",
      // "vv_product_select_ab_test",
      // "vv_product_select_banter",
    ],
  },
  {
    label: "Total VIP Collection Views",
    name: "vip_show_request",
    events: [
      "vip_show_request",
      "vip_show_request_ab_test",
      "vip_show_request_banter",
    ],
  },
  // {
  //     label: "Average Session Time",
  //     name: "vv_user_session_end",
  //     events : [
  //         "vv_user_session_end",
  //         "vv_user_session_end_banter"
  //     ]
  // },
  {
    label: "Total Category Views",
    name: "all_categories_show_request",
    events: ["all_categories_show_request"],
  },
  {
    label: "Total Product Shares",
    name: "product_info_share_request",
    events: ["product_info_share_request"],
  },
];

export const PagodaProductData = [
  {
    query: `SELECT param2.value.string_value AS keyname, count(1) AS value FROM
        \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE param1.key = 'vv_store_name' and param2.key = 'vv_screen_name' and event_name = 'vv_product_select'`,
    label: "Product Select by Screen Name",
    headers: [
      { label: "Screen Name", key: "keyname" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1 order by value desc`,
  },
  {
    query: `SELECT param2.value.string_value AS keyname, count(1) AS value FROM
        \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE param1.key = 'vv_store_name' and param2.key = 'vv_user_session_type' and event_name = 'vv_product_select'`,
    label: "Product Select by User Session Type",
    headers: [
      { label: "Screen Name", key: "keyname" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1 order by value desc`,
  },
  {
    query: `SELECT param2.value.string_value AS screen_name , param1.value.string_value as product_sku, count(1) AS value
        FROM \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1,UNNEST(event_params) AS param3, UNNEST(event_params) AS param2 WHERE (param1.key = 'vv_product_sku' and param2.key = 'vv_screen_name') and (event_name = 'vv_product_select_ab_test' or event_name = 'vv_product_select' or event_name = 'vv_product_select_banter') and (param3.key = 'vv_store_name') `,
    label: "Product Select Details",
    headers: [
      { label: "Product SKU", key: "product_sku" },
      { label: "Screen Name", key: "screen_name" },
      { label: "Product Name", key: "productName" },
      { label: "Event Count", key: "value" },
      // { label: "Category", key: "category" },
      { label: "Listname", key: "listName" },
      { label: "Price", key: "price" },
      { label: "Value", key: "pricevalue" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "a304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "bb872ca6-7b27-4300-b5a6-5b188712fc16",
    },
    customData: ["productName", "listName", "price"],
    appendquery: `group by 1,2 order by value desc`,
  },
  {
    query: `SELECT param1.value.string_value AS storename, param2.value.string_value AS keyname, count(1) AS value FROM 
        \`pagoda-cms-prod.analytics_211897923.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE param1.key = 'vv_store_name' and param2.key = 'vv_user_session_type' and event_name = 'vv_user_session_start' `,
    label: "User Session Request",
    headers: [
      { label: "Store Name", key: "storename" },
      { label: "Screen Name", key: "keyname" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
];
